import React, { FC } from "react";
import Error from "../../../components/Error";
import { ProgramCard } from "./Card/ProgramCard";
import Pagination from "./Pagination";
import {
  ILanguageCourseCardFrontEndModel,
  IProgramCardFrontEndModel,
} from "../types";
import { LanguageCourseCard } from "./Card/LanguageCourseCard";
import { useCardsPage } from "../cardsPageContext";

const ProgramsList: FC = () => {
  const {
    paginationConfig,
    setPaginationConfig,
    programs = [],
    totalCount = 0,
  } = useCardsPage();

  const isProgram = programs[0]?.hasOwnProperty("programType");

  return (
    <>
      {!programs.length ? (
        <Error icon={"search"} text={"You have no results for now."} />
      ) : (
        <>
          {programs.map((program) =>
            isProgram ? (
              <ProgramCard
                key={program.id}
                program={program as IProgramCardFrontEndModel}
              />
            ) : (
              <LanguageCourseCard
                key={program.id}
                course={program as ILanguageCourseCardFrontEndModel}
              />
            ),
          )}
          <Pagination
            totalCount={totalCount}
            config={paginationConfig}
            onChange={setPaginationConfig}
            label={isProgram ? "programs" : "courses"}
          />
        </>
      )}
    </>
  );
};

export default React.memo(ProgramsList);
